import createLucideIcon from '../createLucideIcon';

const CaseUpper = createLucideIcon('CaseUpper', [
  ['polyline', { points: '3,15 7,7 11,15', key: '6kwx87' }],
  ['line', { x1: '4', x2: '10', y1: '13', y2: '13', key: 'f4ax0e' }],
  ['path', { d: 'M15 7h4c1.1 0 2 .9 2 2s-.9 2-2 2h-4V7z', key: '7mjl0c' }],
  ['path', { d: 'M15 11h4.5c1.1 0 2 .9 2 2s-.9 2-2 2H15v-4z', key: 'z0aqar' }],
]);

export default CaseUpper;
